import { Link } from 'react-router-dom';
import { peId, peLabel } from './peClient';

export function PePage({ title, lede, children }) {
  return (
    <>
      <span className="badge">Payroll Engine</span>
      <h1 className="hero-title" style={{ fontSize: '1.85rem' }}>{title}</h1>
      {lede ? <p className="lede">{lede}</p> : null}
      {children}
    </>
  );
}

export function PeNotice({ error, busy, message }) {
  return (
    <>
      {error ? <p className="error">{error}</p> : null}
      {busy ? <p className="muted">Working…</p> : null}
      {message ? <p className="status-ok">{message}</p> : null}
    </>
  );
}

export function NeedTenant() {
  return (
    <section className="panel">
      <h2>Select a tenant</h2>
      <p className="muted">Open a Payroll Engine tenant first. Divisions, users, and employees live under that tenant.</p>
      <p style={{ marginTop: 12 }}>
        <Link className="btn btn-primary" to="/app/tenants">Tenants</Link>
      </p>
    </section>
  );
}

export function PeTable({ columns, rows, onOpen, onDelete, empty, actions }) {
  if (!rows?.length) {
    return <p className="muted" style={{ marginTop: 12 }}>{empty || 'None yet.'}</p>;
  }
  const hasActions = onOpen || onDelete || (actions && actions.length);
  return (
    <table className="pay-grid">
      <thead>
        <tr>
          {columns.map((col) => <th key={col.key}>{col.label}</th>)}
          {hasActions ? <th /> : null}
        </tr>
      </thead>
      <tbody>
        {rows.map((row) => {
          const id = peId(row);
          return (
            <tr key={id || peLabel(row)}>
              {columns.map((col) => (
                <td key={col.key}>{col.render ? col.render(row) : String(row[col.key] ?? row[col.alt] ?? '—')}</td>
              ))}
              {hasActions ? (
                <td className="row-actions">
                  {onOpen ? (
                    <button type="button" className="btn btn-ghost" onClick={() => onOpen(row)}>Open</button>
                  ) : null}
                  {(actions || []).map((action) => (
                    <button
                      key={action.id}
                      type="button"
                      className="btn btn-ghost"
                      disabled={!!action.disabled?.(row)}
                      onClick={() => action.onClick(row)}
                    >
                      {typeof action.label === 'function' ? action.label(row) : action.label}
                    </button>
                  ))}
                  {onDelete ? (
                    <button type="button" className="btn btn-ghost" onClick={() => onDelete(row)}>Delete</button>
                  ) : null}
                </td>
              ) : null}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}

export function TabBar({ tabs, active, onChange }) {
  return (
    <div className="pe-tabs">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          type="button"
          className={`pe-tab${active === tab.id ? ' active' : ''}`}
          onClick={() => onChange(tab.id)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}
